export enum ArrivalWindow {
  from7to8 = 'from7to8',
  from8to9 = 'from8to9',
  from9to10 = 'from9to10',
  from13to15 = 'from13to15',
  from16to19 = 'from16to19',
}
